module.exports = __webpack_public_path__ + "img/DSC_0001.c2d0ed28.jpg";